import { RnClipboardHouse, RnHammerX, RnHeart, RnHome, RnHomeHeart, RnKey, RnUserQuestion } from "@remi/icons/next";
import { PersonTagOption } from "@remi/types/personTagOption";

export const PersonTagIcons: Partial<Record<PersonTagOption, React.ReactElement>> = {
  [PersonTagOption.HOMEOWNER]: <RnHome />,
  [PersonTagOption.SPOUSE]: <RnHomeHeart />,
  [PersonTagOption.FAMILY_MEMBER]: <RnHeart />,
  [PersonTagOption.EXTERNAL_ROOFER]: <RnHammerX />,
  [PersonTagOption.INSURANCE_AGENT]: <RnClipboardHouse />,
  [PersonTagOption.OTHER]: <RnKey />,
  [PersonTagOption.TENANT]: <RnUserQuestion />,
};
